exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* search button */\n.search_field_component {\n  position: relative;\n  font-size: 18px;\n  padding-bottom: 20px; }\n  .search_field_component label {\n    position: absolute;\n    left: 17px;\n    top: 11px; }\n  .search_field_component span {\n    position: absolute;\n    top: 10px;\n    right: 17px;\n    color: #d4d7de;\n    cursor: pointer; }\n  .search_field_component .shadow_effect {\n    -webkit-box-shadow: 0 7px 6px -6px #777;\n    box-shadow: 0 7px 6px -6px #777; }\n  .search_field_component #search-input {\n    padding-left: 43px;\n    padding-right: 43px;\n    border-radius: 23px !important;\n    border: 1px solid #aaa; }\n  .search_field_component input {\n    width: 100%;\n    height: 46px;\n    padding: 10px 16px;\n    font-size: 18px;\n    line-height: 1.3333333; }\n  .search_field_component .fa-times-circle {\n    color: var(--primary-light-blue); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/searchField/SearchField.styles.scss
// module id = 1518
// module chunks = 0